import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { CspPath } from '../../../CspPath';
import { PathUtil } from '../util/PathUtil';

const Layout = React.lazy(() => import('../../reports/component/ReportsLayout'));
const DataChangesPage = React.lazy(() => import('../../reports/data-changes/page/DataChangesPage'));
const StudyDataReportsPage = React.lazy(() => import('../../reports/study-data/page/StudyDataReportsPage'));
const AuditTrailReportPage = React.lazy(() => import('../../reports/audit-trail/page/AuditTrailReportPage'));

export const ReportsRoutes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: PathUtil.toRelativePath(CspPath.REPORTS, CspPath.REPORTS_DATA_CHANGES, true),
        element: <DataChangesPage />,
      },
      {
        path: PathUtil.toRelativePath(CspPath.REPORTS, CspPath.REPORTS_STUDY_DATA, true),
        element: <StudyDataReportsPage />,
      },
      {
        path: PathUtil.toRelativePath(CspPath.REPORTS, CspPath.REPORTS_AUDIT_TRAIL, true),
        element: <AuditTrailReportPage />,
      },
      {
        path: '*',
        element: <Navigate to={CspPath.REPORTS_DATA_CHANGES} replace />,
      },
    ],
  },
];
